import Grid from 'semantic-ui-react/dist/commonjs/collections/Grid';
import '@purple/semantic-ui-family-connection-theme/components/grid.css';

export default Grid;
